export default __webpack_public_path__ + "static/meshery-deployment-e838de74f84b311b97482e2a4a9228c5.webp";